import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {ref, computed, watch} from 'vue';
    import {bool, object, string} from 'vue-types';
    import Calendar from 'primevue/calendar';
    import dateFnsFormat from 'date-fns/format';
    import {onClickOutside} from '@vueuse/core';
    import {setupCalendarTranslations} from './setupCalendarTranslations';
    import {stringToDate, WrongFormattedDateError} from './dateConverter';
    import {isTouchDevice} from './helpers';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'VJoyCalendar',
  props: {
        modelValue: object<Date>(),
        error: bool().def(false),
        disabled: bool().def(false),
        optionalLabel: string(),
        dataTestid: string(),
        datePattern: string().isRequired,
        datePatternRegex: string().isRequired,
        placeholder: string().def(''),
        minDate: object<Date>(),
        maxDate: object<Date>(),
    },
  emits: ['update:modelValue', 'toggled'],
  setup(__props, { emit }) {

const props = __props;

    

    

    setupCalendarTranslations();

    const inputValue = computed(() => {
        if (!props.modelValue) {
            return '';
        }

        // We're using a default input date for touch devices, it requires ISO8601 formatted date as value
        return isTouchDevice() ? dateFnsFormat(props.modelValue, 'yyyy-MM-dd') : dateFnsFormat(props.modelValue, props.datePattern);
    });

    const calendarValue = computed(() => (props.modelValue && !isNaN(props.modelValue.valueOf()) ? props.modelValue : ''));

    const calendarOpened = ref(false);
    const calendarOnTop = ref(false);
    const datePickerRef = ref<HTMLElement | null>(null);

    watch(calendarOpened, () => {
        emit('toggled', calendarOpened.value);
    });

    onClickOutside(datePickerRef, () => {
        if (calendarOpened.value) {
            calendarOpened.value = false;
        }
    });

    function handleInputClick() {
        if (!isTouchDevice() && datePickerRef.value) {
            calendarOnTop.value = window.innerHeight - datePickerRef.value.getBoundingClientRect().top < 400;
            calendarOpened.value = true;
        }
    }

    function handleInputValueChange(event: CustomEvent) {
        const stringValue = event.detail.value;

        try {
            const dateValue = stringToDate(stringValue, isTouchDevice(), props.datePattern, props.datePatternRegex);

            emit('update:modelValue', dateValue || undefined);
        } catch (error) {
            // Nothing to do if the date is wrongly formatted: the user is probably typing the date
            if (!(error instanceof WrongFormattedDateError)) {
                throw error;
            }
        }
    }

    function handleCalendarValueChange(value: Date) {
        calendarOpened.value = false;
        emit('update:modelValue', value);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_input = _resolveComponent("joy-input")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "datePickerRef",
    ref: datePickerRef,
    class: "joy-calendar"
  }, [
    _createVNode(_component_joy_input, {
      type: _unref(isTouchDevice)() ? 'date' : 'text',
      placeholder: __props.placeholder,
      "optional-label": __props.optionalLabel,
      invalid: __props.error,
      value: inputValue.value,
      "data-testid": __props.dataTestid,
      disabled: __props.disabled,
      icon: "calendar",
      onValueChange: handleInputValueChange,
      onClick: handleInputClick
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["type", "placeholder", "optional-label", "invalid", "value", "data-testid", "disabled"]),
    (calendarOpened.value)
      ? (_openBlock(), _createBlock(_unref(Calendar), {
          key: 0,
          disabled: __props.disabled,
          inline: "",
          class: _normalizeClass(["joy-calendar__calendar", {'joy-calendar__calendar--top': calendarOnTop.value}]),
          minDate: __props.minDate,
          maxDate: __props.maxDate,
          modelValue: calendarValue.value,
          "onUpdate:modelValue": handleCalendarValueChange
        }, null, 8, ["disabled", "class", "minDate", "maxDate", "modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})